import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class SnackBarService {
    constructor(private _snackBar: MatSnackBar, private translate: TranslateService) {}

    openSnackBar(message: string, succeeded: boolean = true, duration: number = 3000) {
        const verticalPosition = 'top';
        const horizontalPosition = 'end';
        const panelClass = [succeeded ? 'success-snackbar' : 'error-snackbar'];
        const config: MatSnackBarConfig = { verticalPosition, horizontalPosition, duration, panelClass };

        const msg = this.translate.instant(message);
        this._snackBar.open(msg, '', config);
    }
}
